<template>
  <article class="user_view">
    <left-menu/>
    <select-device @cancel="onCancel" :typeSelection="'single'" :company="selectedCompany" @select="onSelect" v-if="showModal"/>
    <section class="new_user">
      <div @click="$router.push({ name: 'Devices' })" class="back_button">
        <img src="./../../assets/img/icons/back-button.svg">
        <span>atrás</span>
      </div>
      <section class="new_user__form">
        <h1> Crear dispositivo </h1>
        <div class="new_user__form--input-sec">
          <div class="form_input">
            <label>Nombre</label>
            <input v-model="device.name" title="La generación del nombre es automática" disabled placeholder="Nombre"/>
          </div>
          <!--div class="form_input">
            <label>IMEI</label>
            <input v-model="device.imei" placeholder="Número IMEI"/>
          </div-->
          <div class="form_input">
            <label>Número de teléfono</label>
            <input v-model="device.sim" type="number" placeholder="Número de sim (teléfono)"/>
          </div>
          <div class="form_input">
            <label>Empresa</label>
            <input style="cursor: pointer;" v-model="device.company" @click="showModal = true" placeholder="Seleccione"/>
          </div>
          
        </div>
        <div style="margin-bottom:10px">
          <h5  class="login__sect-right__form--error">{{errorMessage}}</h5> 
        </div>
        <button class="secondary_button" :class="{'click':isCreated,'active': isComplete()}" @click.prevent="createDev" :style="{width: '160px', height:'46px'}">CREAR</button>
      </section>
    </section>
  </article>
</template>

<script>

export default {
  data(){
    return{
      isCreated:false,
      device: {
        name: '',
        imei: '',
        sim: '',
        company:''
      },
      showModal: false,
      selectedCompany:{},
      errorMessage:"",
    }
  },
  methods:{
      createDev(){
        this.isCreated=true;  
        setTimeout(() => { this.isCreated=false; }, 200);
        const customActions={
            createDevice: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'POST'}                   
        };
        this.resource= this.$resource('devices',{},customActions);
        this.resource.createDevice({
          device:{
            name: this.device.name,
            //imei: this.device.imei,
            number:this.device.sim,
            
          },
          company: this.selectedCompany.nit,
          admin: JSON.parse(localStorage.getItem('user')).id_card
        })
        .then(function(data){
          this.$router.push({ name: 'Devices' });
        }).catch(function(err){
          var errorlog=Object.keys(JSON.parse(err.bodyText).errors)[0];
          if (JSON.parse(err.bodyText).errors[errorlog][0]){
            if(JSON.parse(err.bodyText).errors[errorlog][0]=="has already been taken"){
              this.errorMessage="El número de teléfono ya se encuentra registrado"             
            }else{
              this.errorMessage="Ha ocurrido un error en la creación, intentelo de nuevo"
            }
          }else{
            this.errorMessage="Ha ocurrido un error en la creación, intentelo de nuevo"
          }
        });
      },
      isComplete(){
        if(this.device.name!=''  && this.device.sim!='' && this.device.company!=''){
          return true;
        }
        
      },
      onCancel(value){
        this.showModal = value;
      },
      onSelect(value){
        this.showModal = false;
        this.selectedCompany =value;
        this.device.company = value.name;
        
      },
      nameDevice(){
        // Obtener el siguiente ID a asignar
        const customActions = {
          getConsecutive: {headers:{"Authorization" : 'Bearer '+ localStorage.getItem('crypto')},method: 'GET'}                   
        };
        this.resource = this.$resource('device/nameConsecutive',{},customActions);
        this.resource.getConsecutive({}).then(function(data){
          this.device.name = 'Dispositivo'+data.body.Number;
        }).catch(function(err){
          console.log('ERROR');
          console.log(err);
        });
        }
    },
    created(){
      this.nameDevice();
    },
}
</script>


// WEBPACK FOOTER //
// src/components/pages/CreateDevice.vue